import React, { useCallback, useState } from 'react'

import { useRouter } from 'next/navigation'

import { CaretDown } from '@phosphor-icons/react'
import { Popover, Text } from 'Components/UI'

import { NAVIGATION_BASE, NAVIGATION_DROPDOWN } from 'Constants/Navigation'

import { Container, Dropdown, NavButton, StyledButton } from './styles'

function DesktopNavigation() {
  const router = useRouter()

  const [dropdownVisible, setDropdownVisible] = useState(false)

  const handleClick = useCallback(
    (path: string) => {
      setDropdownVisible(false)

      router.push(path)
    },
    [router],
  )

  const isTouchDevice =
    typeof window !== 'undefined' && navigator.maxTouchPoints > 0

  return (
    <Container p={6}>
      {NAVIGATION_BASE.map(item => (
        <NavButton
          key={item.id}
          p={[4, 4, 4, 4, 4, 6]}
          onClick={() => handleClick(item.path)}
        >
          <Text important medium nowrap screen16>
            {item.label}
          </Text>
        </NavButton>
      ))}

      <Popover
        content={
          <Dropdown>
            {NAVIGATION_DROPDOWN.map(item => (
              <NavButton
                key={item.id}
                py={4}
                onClick={() => handleClick(item.path)}
              >
                <Text important medium nowrap screen16>
                  {item.label}
                </Text>
              </NavButton>
            ))}
          </Dropdown>
        }
        delay={100}
        offsetOptions={{ mainAxis: -8, crossAxis: -32 }}
        open={dropdownVisible}
        trigger={isTouchDevice ? 'click' : 'hover'}
        onOpenChange={setDropdownVisible}
      >
        <StyledButton iconRotated={dropdownVisible}>
          <Text important medium nowrap screen16>
            Clubhouse
          </Text>

          <CaretDown weight="bold" />
        </StyledButton>
      </Popover>
    </Container>
  )
}

export default DesktopNavigation
